import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import withMatch from '@/hocs/withMatch';
import withApiData from '../../../../services/withApiData';
import styled from 'styled-components';
import { performApiRequest, invalidateApiDataRequest, getApiDataRequest } from '../../../../redux/apiData';
import { fonts, colorPalette } from './../../../../styles/styleGuide';
import BigFieldLabel from './BigFieldLabel';
import ErrorMessage from './ErrorMessage';
import ButtonUpload from '../../buttons/ButtonUpload';
import UserAvatar from '../../../UserAvatar';
import Spinner from '../../ui/Spinner';
import get from 'lodash.get';
import onNetworkStatusChange from '@/processes/onNetworkStatusChange';
var connectApiData = withApiData({
  profile: 'getProfile'
}, function (ownProps) {
  var projectSlug = ownProps.match.params.projectSlug;
  return {
    profile: {
      projectSlug: projectSlug
    }
  };
});
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var projectSlug = ownProps.match.params.projectSlug;
  return {
    postUserProfilePictureRequest: getApiDataRequest(state.apiData, 'postUserProfilePicture', {
      projectSlug: projectSlug
    }),
    postCustomerProfilePictureRequest: getApiDataRequest(state.apiData, 'postCustomerProfilePicture', {
      projectSlug: projectSlug
    })
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var projectSlug = ownProps.match.params.projectSlug;
  return {
    postUserProfilePicture: function postUserProfilePicture(changedValues) {
      dispatch(performApiRequest('postUserProfilePicture', {
        projectSlug: projectSlug
      }, changedValues));
    },
    postCustomerProfilePicture: function postCustomerProfilePicture(changedValues) {
      dispatch(performApiRequest('postCustomerProfilePicture', {
        projectSlug: projectSlug
      }, changedValues));
    },
    invalidateGetProfile: function invalidateGetProfile() {
      dispatch(invalidateApiDataRequest('getProfile', {
        projectSlug: projectSlug
      }));
    }
  };
};
var ProfilePhotoUpload = /*#__PURE__*/function (_Component) {
  function ProfilePhotoUpload() {
    var _this;
    _classCallCheck(this, ProfilePhotoUpload);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ProfilePhotoUpload, [].concat(args));
    _defineProperty(_this, "fileInput", null);
    _defineProperty(_this, "state", {
      isValid: true
    });
    _defineProperty(_this, "handleClick", function (evt) {
      evt.preventDefault();
      if (_this.fileInput) {
        _this.fileInput.click();
      }
    });
    _defineProperty(_this, "handleFileUpload", function (evt) {
      var _this$props = _this.props,
        uploadType = _this$props.uploadType,
        postUserProfilePicture = _this$props.postUserProfilePicture,
        postCustomerProfilePicture = _this$props.postCustomerProfilePicture;
      var file = evt.target.files[0];
      if (file.size >= 2000000) {
        _this.setState({
          isValid: false
        });
        return;
      }
      _this.setState({
        isValid: true
      }, function () {
        var formData = new FormData();
        formData.append('file', file);
        var upload = uploadType === 'user' ? postUserProfilePicture : postCustomerProfilePicture;
        upload(formData);
      });
    });
    return _this;
  }
  _inherits(ProfilePhotoUpload, _Component);
  return _createClass(ProfilePhotoUpload, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
        invalidateGetProfile = _this$props2.invalidateGetProfile,
        postUserProfilePictureRequest = _this$props2.postUserProfilePictureRequest,
        postCustomerProfilePictureRequest = _this$props2.postCustomerProfilePictureRequest;
      onNetworkStatusChange({
        onSucces: invalidateGetProfile
      }, prevProps.postUserProfilePictureRequest, postUserProfilePictureRequest);
      onNetworkStatusChange({
        onSucces: invalidateGetProfile
      }, prevProps.postCustomerProfilePictureRequest, postCustomerProfilePictureRequest);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        profile = _this$props3.profile,
        label = _this$props3.label,
        uploadType = _this$props3.uploadType,
        color = _this$props3.color;
      var isValid = this.state.isValid;
      var imageUrl = uploadType === 'user' ? get(profile, 'data.image', undefined) : get(profile, 'data.customer.customerImage', undefined);
      return __jsx(Container, {
        "data-id": "fieldTypes_ProfilePhotoUpload_Container"
      }, __jsx(BigFieldLabel, {
        label: label,
        "data-id": "fieldTypes_ProfilePhotoUpload_BigFieldLabel"
      }), __jsx(Bottom, {
        "data-id": "fieldTypes_ProfilePhotoUpload_Bottom"
      }, __jsx(UserImage, {
        "data-id": "fieldTypes_ProfilePhotoUpload_UserImage"
      }, profile.request.networkStatus === 'loading' && __jsx(SpinnerContainer, {
        "data-id": "fieldTypes_ProfilePhotoUpload_SpinnerContainer"
      }, __jsx(Spinner, {
        monochrome: true,
        color: colorPalette.blue,
        size: "small",
        "data-id": "fieldTypes_ProfilePhotoUpload_Spinner"
      })), __jsx(UserAvatar, {
        mode: "imageLoader",
        size: "normaler",
        imageUrl: imageUrl,
        phase: uploadType === 'user' ? 'cj1' : 'cj2',
        "data-id": "fieldTypes_ProfilePhotoUpload_UserAvatar"
      }), __jsx(FileInput, {
        type: "file",
        accept: ".jpg, .png",
        ref: function ref(el) {
          _this2.fileInput = el;
        },
        onChange: this.handleFileUpload,
        "data-id": "fieldTypes_ProfilePhotoUpload_FileInput"
      })), __jsx(ButtonUpload, {
        label: "Upload afbeelding",
        clickHandler: this.handleClick,
        "data-id": "fieldTypes_ProfilePhotoUpload_ButtonUpload"
      }), __jsx(ErrorMessage, {
        isValid: isValid,
        message: "De gekozen afbeelding is te groot. Kies een afbeelding die kleiner is dan 2mb.",
        color: color,
        "data-id": "fieldTypes_ProfilePhotoUpload_ErrorMessage"
      })));
    }
  }]);
}(Component);
export default withMatch(connectApiData(connect(mapStateToProps, mapDispatchToProps)(ProfilePhotoUpload)));
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n"])), fonts.primary);
var UserImage = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 70rem;\n  height: 70rem;\n  border-radius: 50%;\n  background-color: ", ";\n  margin-right: 15rem;\n  overflow: hidden;\n  position: relative;\n"])), colorPalette.loadingOrange);
var Bottom = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 10rem 0 0 0;\n"])));
var FileInput = styled.input(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: none;\n"])));
var SpinnerContainer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 2;\n"])));